import { Vue, Component, Prop } from "vue-property-decorator";
import { namespace, Getter } from "vuex-class";
import { EventRecord } from "@/store/site-monitor/types";
import { FeaturesList } from "@/store/types";

const SiteMonitorStore = namespace("siteMonitor");

/**
 * Mixin class for event record components which contains
 * shared logic, vuex store mappings, and component props.
 */
@Component({})
export default class EventRecordsMixin extends Vue {
	@Prop({ type: Number }) public eventid: number;

	@Getter protected isFullUser: boolean;
	@Getter("getFeaturesList") protected featuresList: FeaturesList;

	@SiteMonitorStore.Getter protected filterIndex: number;
	@SiteMonitorStore.Getter("getEventRecords") protected eventRecords: EventRecord[];
	@SiteMonitorStore.Getter("getSelectedEventRecord") protected selectedEventRecord: EventRecord;

	protected get selectedEventRecordId() {
		if (!this.selectedEventRecord) {
			return 0;
		}

		return this.selectedEventRecord.eventRecordID;
	}
}
